import { render, staticRenderFns } from "./LayoutAdmin.vue?vue&type=template&id=54a68202"
import script from "./LayoutAdmin.vue?vue&type=script&lang=js"
export * from "./LayoutAdmin.vue?vue&type=script&lang=js"
import style0 from "./LayoutAdmin.vue?vue&type=style&index=0&id=54a68202&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports